import AbstractFortnoxIntegration from "./AbstractFortnoxIntegration.js";

/**
 * `FortnoxIntegration` is an implementation of `AbstractNewIntegration`
 * for integration with Fortnox.
 */
export default class FortnoxIntegration extends AbstractFortnoxIntegration {
	getName() {
		return "Fortnox";
	}

	routeName() {
		return "fortnox";
	}

	isFortnoxIntegration() {
		return true;
	}

	canBeDisconnected() {
		return true;
	}

	static getType() {
		return "FortnoxIntegration";
	}
}
